var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('p',{staticClass:"my-3 login-or-separator"},[_vm._v(" "+_vm._s(_vm.$t("login.or"))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }